import React from "react";
import { Form } from "antd";
import { useSelector } from "react-redux";
import FormModal from "components/Modal/EditFormModal";
import DrugNameForm from "./DrugNameForm";
const EditDrugName = () => {
  const faqProps = useSelector((state) => state.CurdR);
  const { Edit_DrugName_Modal, initialValues, Loader } = faqProps;
  const [form] = Form.useForm();

  return (
    <div>
      <FormModal
        modalTitle="Edit Drug Names"
        submitButtonText="Update"
        cancelButtonText="Cancel"
        editApiRequest="EditRecord"
        apiLoader="StartSpinner"
        editApiMethod="PUT"
        editApiName="editDrugName"
        ModalName="Edit_DrugName_Modal"
        confirmLoading={Loader}
        ModalType="Hide_Modal"
        visible={Edit_DrugName_Modal ? Edit_DrugName_Modal : false}
        initialValues={initialValues}
        width={550}
        form={form}
        recordName="drugNameList"
      >
        <DrugNameForm />
      </FormModal>
    </div>
  );
};

export default EditDrugName;
